import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Footer from '../containers/footer/footer';
import HeadNav from '../containers/head-nav/head-nav';
import Home from '../pages/home/home';
import Category from '../pages/category/category';
import Post from '../pages/post/post';
import E404 from '../pages/error/e404';
import GalleryCategory from '../pages/gallery-category/gallery-category';
import Rates from '../pages/rates/rates';
import Guide from '../pages/guide/guide';
import Direct from '../pages/direct/direct';
import LoadingInCenter from '../components/loading/loading-in-center';
import AppUpdateRoot from '../components/app-update/AppUpdateRoot';

import './app-style.css';

const Admin = React.lazy(() => import(/* webpackChunkName: "admin" */ '../Admin/Admin'));
const Member = React.lazy(() => import(/* webpackChunkName: "member" */ '../Member/Member'));
const InquiryRoot = React.lazy(() => import(/* webpackChunkName: "inquiry" */ '../../features/customer-inquiry'));

function LazyPage() {
  return (
    <div className="f-grow-1 place-center" style={{ minHeight: 160 }}>
      <LoadingInCenter show fill="#555" width={30} height={30} />
    </div>
  );
}

function App() {
  return (
    <section className="root-section f-grow-1">
      <HeadNav />

      <main className="f-grow-1" role="main">
        <div className="main-container f-grow-1 mb-0">
          <Suspense fallback={<LazyPage />}>
            <Switch>
              <Route exact path={'/'} component={Home} />
              <Route path={'/category/:categoryId/:uniqTitle'} component={Category} />
              <Route path={'/gallery-category/:categoryId/:uniqTitle'} component={GalleryCategory} />
              <Route path={'/post/:id'} component={Post} />
              <Route exact path={'/rates'} component={Rates} />
              <Route path={'/admin'} component={Admin} />
              <Route path={'/member'} component={Member} />
              <Route path={'/guide'} component={Guide} />
              <Route path={'/direct/:memberId'} component={Direct} />
              <Route path={'/direct'} component={Direct} />
              <Route path={'/inquiry'} component={InquiryRoot} />
              <Route path={'*'} component={E404} />
            </Switch>
          </Suspense>
        </div>
      </main>

      <Footer />

      <AppUpdateRoot />
    </section>
  );
}

export default App;
